/**
 * algolia_custom_hooks.js — Algolia AI Search & Discovery custom hooks (PlayZoomi).
 *
 * Phase 2: platform logo on InstantSearch /search product cards — top-left corner
 * of the picture, white circle with a dark logo, like the theme product card
 * (snippets/pz-card-platform-badge.liquid; Instant Gaming look, Eugene 2026-09-22).
 * Source of truth: hit.meta.custom.platform (same metafield the card uses). Cards
 * without the metafield get no icon — matching the category card behaviour.
 *
 * Defensive: on any error (or no platform) it returns the DEFAULT template, so the
 * results never break.
 *
 * Формат денег: приложение читает формат магазина из скрытого элемента через
 * innerHTML; с 2026-09-18 формат обёрнут в <span class=money> (BUCKS Currency
 * Converter), и теги уходили покупателю текстом. Здесь элементу оставляется
 * только текст формата — см. keepMoneyFormatPlain.
 */
(function () {
  if (window.__pzAlgoliaHooksLoaded) return;
  window.__pzAlgoliaHooksLoaded = true;

  // Логотипы платформ — те же пути, что в snippets/pz-card-platform-badge.liquid
  // (карточка темы): меняешь логотип — меняй в обоих местах.
  var PATHS = {
    steam: 'M11.979 0C5.678 0 .511 4.86.022 11.037l6.432 2.658c.545-.371 1.203-.59 1.912-.59.063 0 .125.004.188.006l2.861-4.142V8.91c0-2.495 2.028-4.524 4.524-4.524 2.494 0 4.524 2.031 4.524 4.527s-2.03 4.525-4.524 4.525h-.105l-4.076 2.911c0 .052.004.105.004.159 0 1.875-1.515 3.396-3.39 3.396-1.635 0-3.016-1.173-3.331-2.727L.436 15.27C1.862 20.307 6.486 24 11.979 24c6.627 0 11.999-5.373 11.999-12S18.605 0 11.979 0zM7.54 18.21l-1.473-.61c.262.543.714.999 1.314 1.25 1.297.539 2.793-.076 3.332-1.375.263-.63.264-1.319.005-1.949s-.75-1.121-1.377-1.383c-.624-.26-1.29-.249-1.878-.03l1.523.63c.956.4 1.409 1.5 1.009 2.455-.397.957-1.497 1.41-2.454 1.012zm11.415-9.303c0-1.662-1.353-3.015-3.015-3.015-1.665 0-3.015 1.353-3.015 3.015 0 1.665 1.35 3.015 3.015 3.015 1.663 0 3.015-1.35 3.015-3.015zm-5.273-.005c0-1.252 1.013-2.266 2.265-2.266 1.249 0 2.266 1.014 2.266 2.266 0 1.251-1.017 2.265-2.266 2.265-1.253 0-2.265-1.014-2.265-2.265z',
    xbox: 'M4.102 21.033A11.947 11.947 0 0 0 12 24a11.96 11.96 0 0 0 7.902-2.967c1.877-1.912-4.316-8.709-7.902-11.417-3.582 2.708-9.779 9.505-7.898 11.417zm11.16-14.406c2.5 2.961 7.484 10.313 6.076 12.912A11.942 11.942 0 0 0 24 12.004a11.95 11.95 0 0 0-3.57-8.536s-.027-.022-.082-.042a.847.847 0 0 0-.281-.045c-.592 0-1.985.434-4.805 3.246zM3.654 3.426c-.057.02-.082.041-.086.042A11.956 11.956 0 0 0 0 12.004c0 2.854.998 5.473 2.661 7.533-1.401-2.605 3.579-9.951 6.08-12.91-2.82-2.813-4.216-3.245-4.806-3.245a.844.844 0 0 0-.281.046v-.002zM12 4.954S9.055 3.226 6.755 3.146h-.009c-.155 0-.483.044-.937.224C8.391 1.252 11.33.215 11.996.215h.008c.666 0 3.605 1.037 6.187 3.155-.454-.18-.782-.224-.937-.224h-.009c-2.3.08-5.245 1.808-5.245 1.808z',
    ps: 'M8.984 2.596v17.547l3.915 1.261V6.688c0-.69.304-1.151.794-.991.636.18.76.814.76 1.505v5.875c2.441 1.193 4.362-.002 4.362-3.152 0-3.237-1.126-4.675-4.438-5.827-1.307-.448-3.728-1.186-5.39-1.502zm4.656 16.241 6.296-2.275c.715-.258.826-.625.246-.818-.586-.192-1.637-.139-2.357.123l-4.205 1.499v-2.385l.24-.085s1.201-.42 2.913-.615c1.696-.18 3.785.029 5.437.661 1.848.601 2.04 1.472 1.576 2.072s-1.622 1.036-1.622 1.036l-8.544 3.107v-2.297zM1.807 18.6c-1.9-.545-2.214-1.668-1.352-2.32.801-.586 2.16-1.052 2.16-1.052l5.615-2.013v2.313L4.205 17c-.705.272-.825.65-.239.846.586.195 1.637.15 2.343-.12l1.921-.7v2.062c-.122.024-.258.048-.383.072-1.921.314-3.972.182-6.04-.56z',
    nintendo: 'M14.176 24h3.674c3.376 0 6.15-2.774 6.15-6.15V6.15C24 2.775 21.226 0 17.85 0H14.1c-.074 0-.15.074-.15.15v23.7c-.001.076.075.15.226.15zm4.574-13.199c1.351 0 2.399 1.125 2.399 2.398 0 1.352-1.125 2.4-2.399 2.4-1.35 0-2.4-1.049-2.4-2.4-.075-1.348 1.05-2.398 2.4-2.398zM11.4 0H6.15C2.775 0 0 2.775 0 6.15v11.7C0 21.226 2.775 24 6.15 24h5.25c.074 0 .15-.074.15-.15V.15c.001-.076-.075-.15-.15-.15zM9.676 22.275H6.15c-2.475 0-4.425-1.95-4.425-4.425V6.15c0-2.475 1.95-4.425 4.426-4.425h3.45zM3.75 7.199c0 1.275.975 2.25 2.25 2.25s2.25-.975 2.25-2.25S7.275 4.95 6 4.95s-2.25.975-2.25 2.249z'
  };

  // Пути иконок нужны и модалке автокомплита (assets/algolia-search-modal.js):
  // там строка выдачи рисуется поверх чужой разметки, хука шаблона нет.
  // Отдаём наружу, чтобы не держать вторую копию SVG.
  window.PZ_PLATFORM_PATHS = PATHS;

  // Логотип для круга на карточке /search — CSS-переменная --pz-platform-icon
  // (рисует .ais-hit::before в assets/algolia-custom.css). Считаем один раз.
  function buildPlatformIconUrl(path) {
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
      '<path fill="#0b1018" d="' + path + '"/></svg>';
    return 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
  }
  var PLATFORM_ICON_URLS = {
    xbox: buildPlatformIconUrl(PATHS.xbox),
    ps: buildPlatformIconUrl(PATHS.ps),
    nintendo: buildPlatformIconUrl(PATHS.nintendo)
  };

  // Какая платформа у товара. Steam (он же у всех PC) в выдаче /search не
  // показываем — Евгений 2026-09-22: платформа и так в названии; значок Steam —
  // только на странице товара. Путь PATHS.steam сейчас никто не рисует —
  // оставлен, чтобы значок можно было вернуть одной строкой.
  // На /search круг один — первая по порядку xbox → ps → nintendo (у ::before
  // один фон); карточка темы рисует все найденные.
  function detectPlatformKey(text) {
    var p = String(text || '').toLowerCase();
    if (p.indexOf('xbox') > -1) return 'xbox';
    if (p.indexOf('playstation') > -1 || p.indexOf('psn') > -1 || p.indexOf('ps5') > -1 || p.indexOf('ps4') > -1) return 'ps';
    if (p.indexOf('nintendo') > -1 || p.indexOf('switch') > -1) return 'nintendo';
    return null;
  }

  // Скрытый элемент приложения Algolia с форматом денег магазина
  // ({{ shop.money_format }}). Приложение берёт его innerHTML при каждом
  // форматировании цены (formatMoney) — и в выдаче /search, и в автодополнении.
  // Внутренняя разметка приложения, не документирована; проверено живьём
  // 2026-10-16. Переименуют — слушатель ниже скажет об этом в консоль.
  var MONEY_FORMAT_SELECTOR = '.algolia-config-money-format';

  // Почему: формат магазина с 2026-09-18 — «<span class=money>${{amount}}</span>»
  // (так его переписал BUCKS, чтобы находить цены в теме). Шаблон приложения
  // подставляет результат formatMoney как ТЕКСТ, и покупатель видел
  // «<span class="money">$36.93</span>» в карточках и в фасете цен. Оставляем
  // элементу только текст формата («${{amount}}»): теги в нём — дефект, а цены
  // Algolia BUCKS и так не конвертирует (PZ-386 — отдельная задача).
  // Возвращает, найден ли элемент.
  function keepMoneyFormatPlain() {
    try {
      var moneyFormatElement = document.querySelector(MONEY_FORMAT_SELECTOR);
      if (!moneyFormatElement) return false;
      var plainFormat = (moneyFormatElement.textContent || '').trim();
      // Пустой формат оставляем приложению — у него есть свой запасной «$».
      // Без вложенных тегов переписывать нечего (идемпотентно).
      if (plainFormat && moneyFormatElement.firstElementChild) {
        moneyFormatElement.textContent = plainFormat;
      }
      return true;
    } catch (e) {
      console.warn('[PZ] money format:', e);
      return true;
    }
  }

  // Скрипт defer: элемент уже в документе, чиним до первого рендера. Повтор на
  // инициализации хуков — страховка на случай, если BUCKS или само приложение
  // перерисуют элемент между загрузкой скрипта и инициализацией.
  keepMoneyFormatPlain();

  document.addEventListener('algolia.hooks.initialize', function () {
    // Здесь приложение точно на странице: нет элемента — сменилась его разметка,
    // и теги в ценах вернутся молча. Пусть хотя бы консоль скажет.
    if (!keepMoneyFormatPlain()) {
      console.warn('[PZ] money-format element not found — Algolia app markup changed?');
    }

    var hooks = window.algoliaShopify && window.algoliaShopify.hooks;
    if (!hooks) return;

    try {
      hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
        try {
          var raw = hit && hit.meta && hit.meta.custom && hit.meta.custom.platform;
          var metaStr = (raw == null) ? '' : (Array.isArray(raw) ? raw.join(' ') : String(raw));
          // Круг рисует .ais-hit::before (assets/algolia-custom.css): карточка
          // приложения позиционирована, и угол картинки — её угол при любой
          // колонке. Отдельный элемент рядом с карточкой в угол не встаёт: у
          // карточки отступ слева зависит от колонки (5% или 0).
          // Prefer the platform metafield; if it yields no known icon, fall back to
          // the title (which encodes the platform, e.g. "... ( Xbox / ... )").
          var platformKey = detectPlatformKey(metaStr) || detectPlatformKey((hit && hit.title) || '');
          if (!platformKey) return _defaultTemplate;

          if (typeof trackSearchAttribution === 'function') trackSearchAttribution(hit);
          return html`<div class="pn-is-card pz-platform-hit" style="--pz-platform-icon: ${PLATFORM_ICON_URLS[platformKey]}">${_defaultTemplate}</div>`;
        } catch (e) {
          console.warn('[PZ] platform hook error:', e);
          return _defaultTemplate;
        }
      });
    } catch (e) {
      console.warn('[PZ] could not register product-template hook:', e);
    }

    // Open the panel on focus so the empty state (popular products) shows.
    // detachedMediaQuery 'none': на мобиле Algolia по умолчанию уходит в
    // detached-режим — заменяет инпут своей кнопкой (нужен второй тап) и
    // рисует свой оверлей. Наша модалка сама полноэкранная (скин
    // pz-search-screen): держим инлайн-режим на всех вьюпортах — один тап,
    // настоящий инпут, панель под ним (инцидент «поиск на мобиле не
    // работает», 2026-07-28).
    try {
      hooks.registerHook('beforeAutocompleteOptions', function (options) {
        try {
          options.openOnFocus = true;
          options.detachedMediaQuery = 'none';
        } catch (e) {}
        return options;
      });
    } catch (e) {
      console.warn('[PZ] beforeAutocompleteOptions not available:', e);
    }
  });
})();
